import RichTextWithLabel from './RichTextWithLabel.js';
export default RichTextWithLabel